// extracted by mini-css-extract-plugin
export var quantityInput = "_jk-0";